import { Alert } from '@servicetitan/anvil2';
import { useFormContext } from 'react-hook-form';
import { useEffect, useRef } from 'react';
import { extractErrors } from './extractErrors';

/**
 * Component to display form validation errors in a summary
 */
export const ValidationSummary = () => {
    const {
        formState: { errors, isSubmitted, isValid },
    } = useFormContext();
    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    }, [scrollRef, errors]);

    if (!isSubmitted || isValid) {
        return null;
    }
    const errorMessages = extractErrors(errors);

    return (
        <Alert
            ref={scrollRef}
            status="danger"
            title="Please fix the following elements and submit again"
        >
            <ul>
                {errorMessages.map((error, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={index}>{error?.message}</li>
                ))}
            </ul>
        </Alert>
    );
};
